import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BadImplementationException, exists, MUSTNeverHappenException } from '@nu-art/ts-common';
import { resolveValueDisplay, valueID_No, valueID_Yes } from '@app/hcs-shared/core';
export const resolveBase = (leftHand, resolvers) => {
    const base = resolvers.resolveVariable(leftHand.id) ?? resolvers.resolveExpression(leftHand.id);
    if (!base)
        return 'Left hand base value not found';
    return base.label ?? base.name.replace('.', ' ');
};
export const PrinterByValue_Boolean = ({ variableName, value }) => {
    if (value && (value._id !== valueID_No && value._id !== valueID_Yes))
        throw new MUSTNeverHappenException('cannot use this printer for non yes no variable');
    if (!value) {
        return _jsx(_Fragment, { children: variableName });
    }
    if (value._id === valueID_No)
        return _jsxs(_Fragment, { children: [_jsx("i", { children: resolveValueDisplay(value) }), " ", variableName] });
    return _jsx(_Fragment, { children: variableName });
};
export const PrinterByValue_Numeric = ({ value, variableName, input }) => {
    return _jsxs(_Fragment, { children: [variableName, " is ", exists(input) ? input : _jsx("i", { children: value })] });
};
export const PrinterByValue_Enum = ({ variableName, value, valuesDropdown }) => {
    if (!value && !valuesDropdown)
        throw new BadImplementationException('cannot use printer without both value and edit mode');
    return _jsxs(_Fragment, { children: [variableName, " is ", exists(valuesDropdown) ? valuesDropdown : _jsx("i", { children: resolveValueDisplay(value) })] });
};
//# sourceMappingURL=utils.js.map